import { render, staticRenderFns } from "./DetailRegistration.vue?vue&type=template&id=58270f60&scoped=true"
import script from "./DetailRegistration.vue?vue&type=script&lang=js"
export * from "./DetailRegistration.vue?vue&type=script&lang=js"
import style0 from "./DetailRegistration.vue?vue&type=style&index=0&id=58270f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58270f60",
  null
  
)

export default component.exports